import { render, staticRenderFns } from "./CompanyEndorsements.vue?vue&type=template&id=4405b98e"
import script from "./CompanyEndorsements.vue?vue&type=script&lang=js"
export * from "./CompanyEndorsements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports